import {
  jb_quote_css_default
} from "./chunk.2KQGP4KD.js";
import {
  Spaceable
} from "./chunk.LK5OUX7S.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-quote/jb-quote.ts
var JbQuote = class extends Spaceable(r) {
  _getContentSpacingProperties() {
    return { grid: "legacy", colsMdUp: 8, type: "text" };
  }
  render() {
    return ke`
      <blockquote class="${Rt({ pullquote: !!this.isPullQuote })}">
        <p>${this.quote}</p>
        <footer>${this.author}</footer>
      </blockquote>
    `;
  }
};
JbQuote.styles = jb_quote_css_default;
__decorateClass([
  n()
], JbQuote.prototype, "author", 2);
__decorateClass([
  n({ type: Boolean })
], JbQuote.prototype, "isPullQuote", 2);
__decorateClass([
  n()
], JbQuote.prototype, "quote", 2);
JbQuote = __decorateClass([
  customElement("jb-quote")
], JbQuote);

export {
  JbQuote
};
